module.exports = __webpack_public_path__ + "img/fineness-2.be52f3e.png";